import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import preval from "preval.macro";
export const getBuildDate = (epoch) => {
  const buildDate = moment(epoch).format("MM-DD-YYYY");
  return buildDate;
};

export function FooterCompact({
  today,
  footerClasses,
  footerContainerClasses,
}) {
  const { t } = useTranslation();
  return (
    <>
      {/* begin::Footer */}
      <div
        className={`footer bg-white py-4 d-flex flex-lg-column  ${footerClasses}`}
        id="kt_footer"
      >
        {/* begin::Container */}
        <div
          className={`${footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
        >
          {/* begin::Copyright */}
          <div className="text-dark order-2 order-md-1">
            <span className="text-muted font-weight-bold mr-2">
              {today} &copy;
            </span>
            {` `}
            <a
              href="https://empowerdatalogistics.com/"
              rel="noopener noreferrer"
              target="_blank"
              className="text-dark-75 text-hover-primary"
            >
              Shipper
            </a>{" "}
            <span className="text-muted mr-2">
              Build Version{" "}
              <a
                href={() => false}
                target="_blank"
                rel="noopener noreferrer"
                className="font-weight-bolder text-muted"
              >
                {window.$appVersion}
              </a>{" "}
              / Build Date:{" "}
              <strong>{preval`module.exports = new Date().toLocaleDateString("en-US");`}</strong>
              .
            </span>
          </div>
          {/* end::Copyright */}
          {` `}
          {/* begin::Nav */}
          <div className="nav nav-dark order-1 order-md-2">
            <span className="nav-link pr-3 pl-0" style={{ cursor: "pointer" }}>
              {t("About")}
            </span>
            <span className="nav-link px-3" style={{ cursor: "pointer" }}>
              {t("Team")}
            </span>
            <span className="nav-link pl-3 pr-0" style={{ cursor: "pointer" }}>
              {t("Contact")}
            </span>
          </div>
          {/* end::Nav */}
        </div>
        {/* end::Container */}
      </div>
      {/* end::Footer */}
    </>
  );
}
